export { default } from './LinkTabs';
